/**
 * Populates the "You may also like" carousel inside the cart drawer, using
 * Shopify's product recommendations endpoint based on the most recently
 * added item, with an inline "+ Add" button per card.
 */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function renderCard(product) {
    var variant = product.variants && product.variants[0];
    var variantId = variant ? variant.id : product.id;
    var price = formatMoney(product.price, window.themeMoneyFormat);
    var compareHtml = '';
    if (product.compare_at_price && product.compare_at_price > product.price) {
      compareHtml =
        '<s class="cart-drawer__rec-compare">' +
        formatMoney(product.compare_at_price, window.themeMoneyFormat) +
        '</s> ';
    }
    var img = product.featured_image || (product.images && product.images[0]);

    var card = document.createElement('div');
    card.className = 'cart-drawer__rec-card';
    card.innerHTML =
      '<a href="' + product.url + '" class="cart-drawer__rec-image-link">' +
        (img
          ? '<img src="' + img + '&width=160" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="72" height="72">'
          : '') +
      '</a>' +
      '<div class="cart-drawer__rec-info">' +
        '<a href="' + product.url + '" class="cart-drawer__rec-title">' + product.title + '</a>' +
        '<p class="cart-drawer__rec-price">' + compareHtml + '<span>' + price + '</span></p>' +
      '</div>' +
      '<button type="button" class="cart-drawer__rec-add" data-variant-id="' + variantId + '">+ Add</button>';

    var btn = card.querySelector('.cart-drawer__rec-add');
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = '...';

      var cartDrawer = document.querySelector('cart-drawer');
      var sectionsToRender = cartDrawer ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; }) : [];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sectionsToRender,
          sections_url: window.location.pathname
        })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            btn.disabled = false;
            btn.textContent = originalText;
            return;
          }
          if (cartDrawer) cartDrawer.renderContents(data);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });

    return card;
  }

  // renderContents() can replace #CartDrawer's innerHTML (creating a brand
  // new #CartDrawer-Recommendations/-Track) while a previous loadRecommendations()
  // call is still mid-flight - without a guard, that stale call's response
  // eventually lands on detached elements nobody sees, while the *current*
  // DOM stays empty. requestToken makes only the most recently started call
  // allowed to write anything, and every DOM read/write below re-queries by
  // id right before use instead of trusting references captured earlier.
  var requestToken = 0;

  function loadRecommendations() {
    var token = ++requestToken;
    var root = document.getElementById('CartDrawer-Recommendations');
    if (!root) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart.items.length) return null;
        var lastItem = cart.items[cart.items.length - 1];
        var url = root.dataset.url + '.json?product_id=' + lastItem.product_id + '&limit=6&intent=related';
        return fetch(url)
          .then(function (res) { return res.json(); })
          .then(function (data) { return { data: data, cart: cart }; });
      })
      .then(function (result) {
        if (token !== requestToken) return; // a newer call has since started - drop this one
        var freshRoot = document.getElementById('CartDrawer-Recommendations');
        var freshTrack = document.getElementById('CartDrawer-RecommendationsTrack');
        if (!freshRoot || !freshTrack) return;

        if (!result) {
          freshRoot.hidden = true;
          return;
        }
        var products = (result.data && result.data.products) || [];
        // Recommendations can include items already in the cart - skip those.
        var cartProductIds = result.cart.items.map(function (i) { return i.product_id; });
        products = products.filter(function (p) { return cartProductIds.indexOf(p.id) === -1; });

        freshTrack.innerHTML = '';
        if (!products.length) {
          freshRoot.hidden = true;
          return;
        }
        products.slice(0, 6).forEach(function (product) {
          freshTrack.appendChild(renderCard(product));
        });
        freshRoot.hidden = false;
        updateArrowState(freshRoot, freshTrack);
      })
      .catch(function () {
        if (token !== requestToken) return;
        var freshRoot = document.getElementById('CartDrawer-Recommendations');
        if (freshRoot) freshRoot.hidden = true;
      });
  }

  function updateArrowState(root, track) {
    var prevBtn = root.querySelector('[data-rec-prev]');
    var nextBtn = root.querySelector('[data-rec-next]');
    if (!prevBtn || !nextBtn) return;
    var atStart = track.scrollLeft <= 4;
    var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    prevBtn.disabled = atStart;
    nextBtn.disabled = atEnd || track.scrollWidth <= track.clientWidth;
  }

  function initCarouselNav() {
    var root = document.getElementById('CartDrawer-Recommendations');
    if (!root || root.dataset.navBound) return;
    root.dataset.navBound = 'true';

    var track = document.getElementById('CartDrawer-RecommendationsTrack');
    var prevBtn = root.querySelector('[data-rec-prev]');
    var nextBtn = root.querySelector('[data-rec-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function scrollByCard(direction) {
      var card = track.querySelector('.cart-drawer__rec-card');
      var amount = card ? card.getBoundingClientRect().width + 12 : 200;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    nextBtn.addEventListener('click', function () { scrollByCard(1); });
    track.addEventListener('scroll', function () { updateArrowState(root, track); }, { passive: true });
  }

  document.addEventListener('cart-drawer:open', function () {
    loadRecommendations();
    initCarouselNav();
  });

  // The 'cart-drawer:open' event only covers CartDrawer.open() itself, but
  // Dawn re-renders the drawer's contents through two other paths that never
  // call open() and so never fire it:
  //  - CartItems.onCartUpdate() (cart.js): after ANY cartUpdate pub/sub event
  //    not sourced from itself (e.g. product-form.js's add-to-cart publish),
  //    it replaces the whole <cart-drawer-items> element with a freshly
  //    fetched copy - which is why adding from the product page loaded cards
  //    (loadRecommendations re-queries the live element when its response
  //    lands, so it still found a home) but left the arrow buttons dead: this
  //    second, later swap created a brand new element that initCarouselNav()
  //    was never called on.
  //  - CartItems.updateQuantity() (cart.js): a quantity change or Remove
  //    click replaces .drawer__inner's innerHTML with a fresh section render,
  //    whose recommendations markup always starts hidden/empty - nothing
  //    reloads it, which is why removing an item made "You may also like"
  //    disappear for good instead of just refreshing.
  // Watching #CartDrawer for the recommendations element being replaced
  // (rather than patching every render path above) reloads and rebinds it
  // regardless of which code triggered the swap.
  var lastObservedRoot = document.getElementById('CartDrawer-Recommendations');
  var cartDrawerRoot = document.getElementById('CartDrawer');
  if (cartDrawerRoot && window.MutationObserver) {
    new MutationObserver(function () {
      var root = document.getElementById('CartDrawer-Recommendations');
      if (root && root !== lastObservedRoot) {
        lastObservedRoot = root;
        loadRecommendations();
        initCarouselNav();
      }
    }).observe(cartDrawerRoot, { childList: true, subtree: true });
  }
})();
